import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackMakeWishListPrivateParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/wishList/trackMakeWishListPrivate";

const useTrackMakeWishListPrivate = (
    parameters: TrackMakeWishListPrivateParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.makeWishListPrivate, parameters, options);
};

export default useTrackMakeWishListPrivate;
